module.exports = __webpack_public_path__ + "static/media/Decoration_Fairytale.bbd63f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Fairytale.png
// module id = 1346
// module chunks = 3